import { Col, Input, Row, Select, Table, Button } from "antd";
import { Field, Form, Formik } from "formik";
import React, { FC, useEffect, useRef, useState } from "react";
import ButtonComponent from "../../../shared/components/ButtonComponent";

import { deserialize, serialize } from "serializr";
import CommonService from "../../../services/CommonService/common.service";
import ChapterwiseReportService from "../../../services/ReportsService/ChapterwiseReport.service";

import { MetaModel } from "../../../models/CourseModels/SubjectModel/subject.model";
import { FilterChapterwise, ChapterwiseSummaryModel } from "../../../models/ReportsModel/chapterwise.model";
import { BASE_URL, DOWNLOAD_CHAPTERWISE_REPORT } from "../../../routes/routeConstants/apiRoutes";
import SectionService from "../../../services/InstituteService/section.service";
import { MetaService } from "../../../services/MetaService/meta.service";
import { BranchClassRoomsModel } from "../../../models/InstituteModel/branches.model";




interface ChapterwiseReportProps {
  institutes: MetaModel[];
  user: any
}

const ChapterwiseReport: FC<ChapterwiseReportProps> = (props) => {
  const { institutes, user } = props;

  const [initialValues, setInitialValues] = useState<FilterChapterwise>({
    type: "institute",
  });
  const [branches, setBranches] = useState<MetaModel[]>([]);
  const [boards, setBoards] = useState<MetaModel[]>([]);
  const [branchClassRoomsMeta, setBranchClassRoomsMeta] = useState<MetaModel[]>([]);
  const [branchClassRooms, setBranchClassRooms] = useState<BranchClassRoomsModel[]>([]);
  const [sections, setSections] = useState<MetaModel[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [sectionSubjects, setSectionSubjects] = useState<MetaModel[]>([]);
  const [chapters, setChapters] = useState<MetaModel[]>([]);

  const [activitySummaryData, setActivitySummaryData] = useState<ChapterwiseSummaryModel[]>([]);
  const formRef = useRef<any>();


  useEffect(() => {
    if (institutes.length && user?.roleName === "instituteadmin") {
      let currentInstituteID = Number(institutes[0].value)
      setInitialValues({ ...initialValues, instituteId: currentInstituteID })
      fetchBranches(currentInstituteID)
    }
  }, [institutes])

  const handleSubmit = (values: FilterChapterwise) => {
    if (values.type === 'institute' && values.boardId && values.branchId) {
      fetchActivityReportByInst(values)
    } else if (values.type === 'onboard' && values.boardId) {
      fetchLearderboardByOnboard(values)
    }
  };

  const fetchActivityReportByInst = (values: FilterChapterwise) => {
    setLoading(true)
    ChapterwiseReportService.fetchChapterwiseReport(
      values,
      (data) => {
        setActivitySummaryData(data);
      },
      () => { },
      () => { setLoading(false) }
    );
  }

  const fetchLearderboardByOnboard = (values: FilterChapterwise) => {
    setLoading(true)
    ChapterwiseReportService.fetchChapterwiseReport(
      values,
      (data) => {
        setActivitySummaryData(data);
      },
      () => { },
      () => { setLoading(false) }
    );
  }

  // Download Report
  const handleDownload = (values: FilterChapterwise) => {
    const payload = serialize(FilterChapterwise, values);
        const user = JSON.parse(localStorage.getItem("token") || "")
        const urlParams = new URLSearchParams({...payload, access_token: user.access_token}).toString()

        window.open(`${BASE_URL}${DOWNLOAD_CHAPTERWISE_REPORT}?${urlParams}`, '_blank')
  }

  const fetchBranches = (id: number) => {
    CommonService.fetchBranchesMeta(
      id,
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setBranches(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchBoards = () => {
    CommonService.fetchBoardsMeta(
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setBoards(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchSections = (branchId: number, classId: number) => {
    SectionService.fetchSectionsMeta(
      { branch_class_room_id: classId },
      (sections: any) => {
        setSections(sections);
      },
      () => { },
      () => { }
    )
  };

  const fetchSectionSubjects = (id: number) => {
    MetaService.fetchInstituteSectionSubjectsMeta(
      [id],
      (data) => {      
        setSectionSubjects(data);
      },
      () => {},
      () => {}
    );
  };

  const fetchChapters = (classId: number, subjectId: number) => {
    const classRoom = branchClassRooms.find(branchClassRoom => branchClassRoom.id == classId)?.classRoom
    CommonService.fetchChaptersMeta(
      { ClassId: classRoom?.id, SubjectId: subjectId },
      (data) => {
        const response = deserialize(MetaModel, data);
        setChapters(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchBranchClassRooms = (branchId: number) => {
    SectionService.fetchBranchClassRooms(
      { branch_id: branchId },
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setBranchClassRooms(data)
        setBranchClassRoomsMeta(meta);
      },
      () => { },
      () => { }
    );
  };


  useEffect(() => {
    fetchBoards();
  }, []);

  const clearForm = () => {
    user?.roleName === "admin" && setBranches([])
    setSections([])
    setSectionSubjects([])
    setChapters([])
    setBranchClassRoomsMeta([])
    setActivitySummaryData([]);
    setLoading(false);
  }




  return (
    <div className="classroom-reports">
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
        innerRef={formRef}
      >
        {({ setFieldValue, values, resetForm, dirty }) => {
          return (
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="institute-reports-filters__container">
                <Row
                  className="classroom-reports-filters__wrapper"
                  gutter={24}
                >
                  <Col span={24}>
                    <Row gutter={[24, 24]}>
                      <Col span={6}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Filter by
                          </div>
                          <Field
                            disabled={user?.roleName === "instituteadmin" ? true : false}
                            as={Select}
                            name="type"
                            options={[
                              {
                                value: "institute",
                                label: "Institute",
                              },
                              {
                                value: "onboard",
                                label: "Self onboarded",
                              },
                            ]}
                            value={values?.type}
                            placeholder="Select Filter"
                            onChange={(value) => {
                              resetForm()
                              setFieldValue("type", value)
                            }}
                          ></Field>
                        </div>
                      </Col>
                      {values?.type == "institute" && (
                        <>
                          <Col span={6}>
                            <div className="institute-reports-filter-field__container">
                              <div className="institute-reports-filter-field__label">
                                Institute
                              </div>
                              <Field
                                disabled={user?.roleName === "instituteadmin" ? true : false}
                                as={Select}
                                name="instituteId"
                                value={values?.instituteId}
                                options={institutes}
                                placeholder="Select Institute"
                                onChange={(value) => {
                                  resetForm()
                                  setFieldValue("instituteId", value);
                                  value && fetchBranches(value);
                                }}
                              ></Field>
                            </div>
                          </Col>
                          <Col span={6}>
                            <div className="institute-reports-filter-field__container">
                              <div className="institute-reports-filter-field__label">
                                Branch
                              </div>
                              <Field
                                as={Select}
                                options={branches}
                                name="branchId"
                                value={values?.branchId}
                                placeholder="Select Branch"
                                onChange={(value) => {
                                  setFieldValue("branchId", value);
                                  setFieldValue("branchClassRoomId", null);
                                  setFieldValue("sectionId", null);
                                  setFieldValue("sectionSubjectId", null);
                                  fetchBranchClassRooms(value);
                                }}
                              ></Field>
                            </div>
                          </Col>
                        </>
                      )}

                      <Col span={6}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Board
                          </div>
                          <Field
                            as={Select}
                            name="boardId"
                            options={boards}
                            value={values?.boardId}
                            placeholder="Select Board"
                            onChange={(value) =>
                              setFieldValue("boardId", value)
                            }
                          ></Field>
                        </div>
                      </Col>
                      <Col span={6}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Class
                          </div>
                          <Field
                            as={Select}
                            name="branchClassRoomId"
                            options={branchClassRoomsMeta}
                            value={values?.branchClassRoomId}
                            placeholder="Select Class"
                            onChange={(value) => {
                              setFieldValue("branchClassRoomId", value);
                              setFieldValue("sectionId", null);
                              setFieldValue("sectionSubjectId", null);
                              setFieldValue("chapterId", null);
                              values?.branchId &&
                                fetchSections(values?.branchId, value);
                            }}
                          ></Field>
                        </div>
                      </Col>
                      {values?.type == "institute" && (
                        <Col span={6}>
                          <div className="institute-reports-filter-field__container">
                            <div className="institute-reports-filter-field__label">
                              Section
                            </div>
                            <Field
                              as={Select}
                              name="sectionId"
                              options={sections}
                              value={values?.sectionId}
                              placeholder="Select Section"
                              onChange={(value) => {
                                setFieldValue("sectionId", value);
                                fetchSectionSubjects(value);
                              }}
                            ></Field>
                          </div>
                        </Col>
                      )}

                      <Col span={6}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Subject
                          </div>
                          <Field
                            as={Select}
                            options={sectionSubjects}
                            name="sectionSubjectId"
                            value={values?.sectionSubjectId}
                            placeholder="Select Subject"
                            onChange={(value) => {
                              setFieldValue("sectionSubjectId", value)
                              setFieldValue("chapterId", null);
                        
                              values?.branchClassRoomId &&
                                fetchChapters(values?.branchClassRoomId, value);
                            }

                            }
                          ></Field>
                        </div>
                      </Col>

                      <Col span={6}>
                        <div className="institute-reports-filter-field__container">
                          <div className="institute-reports-filter-field__label">
                            Chapter
                          </div>
                          <Field
                            as={Select}
                            options={chapters}
                            name="chapterId"
                            value={values?.chapterId}
                            placeholder="Select Chapter"
                            onChange={(value) =>
                              setFieldValue("chapterId", value)
                            }
                          ></Field>
                        </div>
                      </Col>

                      <Col span={6}>
                        <div className="institute-reports-filter-btn__wrapper">
                          <ButtonComponent
                            type="text"
                            buttonContent={"Clear Filters"}
                            onClick={() => {
                              resetForm();
                              clearForm()
                            }}
                          />
                          <ButtonComponent
                            type="primary"
                            loading={loading}
                            buttonContent={"Apply Filters"}
                            onClick={() => handleSubmit(values)}
                          />
                        </div>
                      </Col>

                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="institute-reports-search__container">
                <div></div>
                {activitySummaryData?.length ? (
                  <div>
                    <ButtonComponent
                      type="primary"
                      buttonContent={"Download Report"}
                      onClick={() => handleDownload(values)} />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
      <Table
        columns={[
          {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
          },
          {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
          },
          {
            title: 'Grade',
            dataIndex: 'grade',
            key: 'grade',
          },
          {
            title: 'Section',
            dataIndex: 'section',
            key: 'section',
          },
          {
            title: 'Content Completion',
            dataIndex: 'contentCompletion',
            key: 'contentCompletition'
          },
          {
            title: 'Content Completion Points',
            dataIndex: 'contentCompletionPoints',
            key: 'contentCompletionPoints',
          },
          {
            title: 'Total quick quiz attempted',
            dataIndex: 'quickQuizAttempted',
            key: 'quickQuizAttempted',
          },
          {
            title: 'Total points for quick quizes',
            dataIndex: 'totalQuickQuizPoints',
            key: 'totalQuickQuizPoints',
          },
          {
            title: 'Exercise Attempt',
            dataIndex: 'exerciseAttempted',
            key: 'exerciseAttempted',
          },
          {
            title: 'Total Points for exercieses',
            dataIndex: 'totalExerciesesPoints',
            key: 'totalExerciesesPoints',
          },
          {
            title: 'Over all points for this chapter',
            dataIndex: 'overAllChapterPoints',
            key: 'overAllChapterPoints',
          },
          {
            title: 'Total hours spent for this chapter (minutes)',
            dataIndex: 'totalHoursForChapter',
            key: 'totalHoursForChapter',
          }
          
        ]}
        bordered
        scroll={{ x: 2000 }}
        pagination={{ defaultPageSize: 10 }}
        dataSource={activitySummaryData}
        loading={loading}
      />

    </div>
  );
};

export default ChapterwiseReport;
